import { useTranslation } from 'react-i18next'

export function SlotDirtyDot() {
  const { t } = useTranslation()
  return (
    <span
      role="status"
      aria-label={t('addToProduct.media.dirtyDot.a11y')}
      className="absolute top-2 left-2 w-2.5 h-2.5 bg-amber-400 rounded-full"
    />
  )
}
